import script from "./SiteTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteTabs.vue?vue&type=script&setup=true&lang=ts"

import "./SiteTabs.vue?vue&type=style&index=0&id=9ed4fa3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ed4fa3e"]])

export default __exports__